import { useTranslation } from "react-i18next";
import { OcRoleFilterHeaderProps } from "./role-filter-header";

interface UseRoleFilterHeaderProps {
  title: OcRoleFilterHeaderProps["title"];
}

export const useRoleFilterHeader = ({ title }: UseRoleFilterHeaderProps) => {
  const { t } = useTranslation();
  const translatedTitle = t(title);
  return { translatedTitle };
};
